import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { filterChipLabel } from './filterLabels';
import type { FilterChip } from './filters';
import { ROSTER } from './tokens';

const REMOVE_GLYPH = '#7F7F99';

export function FilterChipPill({
  chip,
  onRemove,
  onEdit,
}: {
  chip: FilterChip;
  onRemove: () => void;
  onEdit: (anchor: HTMLElement) => void;
}) {
  const label = filterChipLabel(chip);
  return (
    <Box
      data-testid="filter-chip"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '999px',
        p: '6px 8px 6px 13px',
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
        border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.25)}`,
        fontFamily: ROSTER.font,
        fontSize: 12,
        fontWeight: 700,
        color: (theme) => theme.palette.primary.dark,
      }}
    >
      <Box
        component="button"
        type="button"
        data-testid="filter-chip-edit"
        aria-label={`Edit filter ${label}`}
        onClick={(event: React.MouseEvent<HTMLElement>) => onEdit(event.currentTarget)}
        sx={{
          background: 'none',
          border: 0,
          p: 0,
          fontFamily: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit',
          color: 'inherit',
          cursor: 'pointer',
        }}
      >
        {label}
      </Box>
      <Box
        component="button"
        type="button"
        data-testid="filter-chip-remove"
        aria-label={`Remove filter ${label}`}
        onClick={onRemove}
        sx={{
          background: 'none',
          border: 0,
          p: '0 2px',
          fontFamily: 'inherit',
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 1,
          color: REMOVE_GLYPH,
          cursor: 'pointer',
          '&:hover': { color: ROSTER.ink },
        }}
      >
        ✕
      </Box>
    </Box>
  );
}
